import { isHouseLevelResult } from './geocoderPrecision'

export interface PersistPointInput {
  /** Номер дома из ответа геокодера (пусто — дом не найден). */
  house?: string | null
  /** Точность ответа геокодера. */
  precision?: string | null
  /** Точка совпала с координатами филиала. */
  atBranch: boolean
  /** Точка попала в зону доставки. */
  inZone: boolean
}

/**
 * Можно ли сделать точку на карте ВЫБРАННЫМ адресом клиента (записать в профиль и
 * хранилище устройства). Показывать её в окне можно всегда — это то, что клиент видит
 * и правит; выбранным адресом становится только пригодная к доставке точка.
 *
 * Три условия:
 *  - геокодер нашёл дом, а не улицу или населённый пункт (иначе адресом клиента
 *    становился центр станицы — кластер из 5 таких адресов и заказ #8300);
 *  - точка не на филиале (стартовая точка карты у клиента без адресов, тот же #8300);
 *  - точка внутри зоны доставки.
 *
 * Последнее условие добавлено 16.09.2026 по жалобе на путаницу: адрес вне зоны
 * записывался выбранным с пустой зоной, после чего `ensureDefaultDeliveryAddress`
 * «чинил» пустую зону, подставляя адрес по умолчанию. В поле подставлялся ДРУГОЙ
 * адрес, а маркер оставался на введённом — и клиент мог не заметить подмены.
 */
export function shouldPersistAddressPoint(input: PersistPointInput): boolean {
  if (!input.inZone) return false
  if (input.atBranch) return false
  return isHouseLevelResult({ house: input.house, precision: input.precision })
}
